/* tslint:disable:no-any */
import { filter } from 'lodash';

import { MobizClientPluginConfiguration } from './mobiz-client-plugin-configuration.do';
import { MobizGroup } from './mobiz-group.do';
import { OrganizationMembership } from './organization-membership.do';
import { SecurityScope } from './security-scope';
import { SerializableObject } from './serializable-object';

/**
 * Dependencies of the organization
 */
export enum OrganizationEagerLoad {
  None = 0,
  LineOfBusiness = 1,
  Membership = 2,
  MembershipUsers = 4,
  MembershipCreatedByUsers = 8,
  Invite = 16,
  InviteCreatedByUsers = 32,
  AdminDomain = 64,
  Endpoint = 128,
  ClientPluginConfigurations = 256,
  All = 511,
}

/** The Organization domain object. */
export class Organization extends SerializableObject {
  public id: string;
  public createdUtc: Date;
  public modifiedUtc: Date;
  public createdBy: string;
  public modifiedBy: string;
  public ssn: string;
  public fullName: string;
  public description: string;
  public website: string;
  public clientPluginConfigurations: MobizClientPluginConfiguration[];
  public email: string;
  public erpDriver: string;
  public erpUrl: string;
  public erpCredentials: string;  // todo use ErpCredentials.do
  public erpAuthSettings: null;
  public erpCompanyId: string;
  public erpStatus: Object;  // todo erpConnectionStatus.do
  public erpTraceLevel: Object;  // todo traceLevel.do
  public members: OrganizationMembership[];
  public lineOfBusinessId: string;
  public lineOfBusiness: Object;  // todo lineOfBusiness.do
  public identificationNumber: string;

  public adminDomainId: string;
  public adminDomain: any;
  public endpointId: string;
  public endpoint: any;
  public invites: any[];

  // tslint:disable-next-line:cyclomatic-complexity
  protected coercePropertyType(propertyName: string, propertyValue: any): any {
    switch (propertyName) {
      case 'members':
        const members: OrganizationMembership[] = [];
        if (Array.isArray(propertyValue)) {
          propertyValue.forEach(memberData => {
            const membership = new OrganizationMembership(memberData);
            members.push(membership);
          });
        }
        return members;

      case 'clientPluginConfigurations':
        const clientPluginConfigurations: MobizClientPluginConfiguration[] = [];
        if (Array.isArray(propertyValue)) {
          propertyValue.forEach(configurationData => {
            const configuration = new MobizClientPluginConfiguration(configurationData);
            clientPluginConfigurations.push(configuration);
          });
        }
        return clientPluginConfigurations;

      // TODO: The API should return a JSON object not a JSON encoded string.
      // case 'erpCredentials':
      //   return new ErpCredentials(JSON.parse(erpCredentialsValue));

      case 'modifiedUtc':
      case 'createdUtc':
        if (typeof propertyValue === 'string') {
          return new Date(propertyValue);
        }
        return propertyValue;

      default:
        return super.coercePropertyType(propertyName, propertyValue);
    }
  }

  /**
   * Returns whether the organization has any type of connection to the ERP.
   */
  public hasAnyErpConnection(): boolean {
    return false;
  }

  /**
   * Returns whether the organization uses a custom ERP connection.
   */
  public hasCustomErpConnection(): boolean {
    return false;
  }

  /**
   * Returns whether the organization uses an Endpoint for the ERP Connection.
   */
  public hasEndpointErpConnection(): boolean {
    return false;
  }

  /**
   * Returns the Groups scoped to the current organization.
   * @param groups The list of groups.
   */
  public filterScopedGroups(groups: MobizGroup[]): MobizGroup[] {
    return filter(groups, group => {
      return group.scope === SecurityScope.BuiltIn ||
        (group.scope === SecurityScope.AdminDomain && group.scopeId === this.adminDomainId) ||
        (group.scope === SecurityScope.Organization && group.scopeId === this.id);
    });
  }

}
